import bus from '../../libs/bus';
import percent from '../../filters/percent-formate';
import dateToTime from '../../filters/date-to-time';

export default {
  /**
   * 除法运算
   * @param {Number} up 分子
   * @param {Number} down 分子
   * @param {Number} remainder 保留几位小数
   */
  division(up, down, remainder) {
    const res = (up / down).toFixed(remainder);
    return res === 'NaN' || res === 'Infinity' ? 0 : res;
  },

  /**
   * 计算指标数据对应的 Metrice数值
   * @param {[Array]} arr [当前指标数据]
   * @param {[String]} key [当前指标标示]
   * return {[Object]} [返回指标数据的总和和均值]
   */
  setMetriceNumber(arr, key = 'value') {
    if (arr instanceof Array) {
      const len = key === 'value' ? -dateToTime(bus.selectedDate) : arr.length;
      let count = 0;
      arr.forEach((x) => {
        count += (x[key] * 1);
      });
      const avg = percent(count / len);
      return {
        count,
        avg,
      };
    }
    return {
      count: '--',
      avg: '--',
    };
  },
  /**
   * yAxis 样式数据
   * @param  {[String]} name [Y轴对应的名称]
   * @param  {[String]} rate [Y轴数据的单位 '%'/ '']
   */
  setyAxisStyle(name, rate = '') {
    const obj = {
      name,
      type: 'value',
      nameTextStyle: {
        color: '#7F8B9C',
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#FFFFFF',
          width: 2,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9',
        },
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C',
        },
        formatter(a) {
          return `${a}${rate}`;
        },
      },
    };
    return obj;
  },
  /**
   * 设置图表 series内容
   * @param {[String]} type       [图表系列的类型 'line'/'bar']
   * @param {[Array]} data       [图表系列的数据]
   * @param {[Sting]} name       [图表系列的名称]
   * @param {[Sting]} stack       [图表系列的堆积图字符]
   * @param {[Number]} yAxisIndex [图表系列对应的 Y轴的index]
   * @param {[Number]} opacity    [图表系列的填充样式，系列类型必须为'line', 取值范围为 0~1]
   */
  setSeries(type, data, name, stack, yAxisIndex, opacity = 0) {
    const obj = {
      type,
      data,
      smooth: true,
      showSymbol: data && data.length === 1,
      name,
      stack,
      yAxisIndex,
      barWidth: type === 'bar' ? 16 : undefined,
      areaStyle: {
        normal: {
          opacity,
        },
      },
    };
    return obj;
  },
  /**
   * 数据请求失败图表提示
   * @param {[String]} key   [当前 tabs标示]
   */
  setErrorView(key) {
    const refsDom = this.$refs[key];
    refsDom.spinShow = false;
    refsDom.errorSpin = true;
  },
};
